<style scoped>
.correct-marker {
  padding-left: 10px;
  padding-right: 10px;
}
.answer-row {
  padding-top: 10px;
}
.quiz-wrapper {
  padding: 8px;
}
.quiz-question {
  margin-top: 20px;
  margin-bottom: 0px;
}
.quiz-submit {
  margin-top: 20px;
  margin-bottom: 10px;
}
.radio {
  padding: 4px;
}
.red-text {
  color: red;
}
.mute-container {
  opacity: 0.0;
  pointer-events: none;
}
.answer-feedback-wrapper {
  padding-left: 30px;
}
.answer-text {
  wordwrap: break-word;
  padding-left: 8px;
}
</style>

<template>

  <div class="quiz-wrapper" v-if="flagFetchedMedia && flagFetchedSubmissions" v-loading="submitting">
    <div v-if="!isQuizShow">{{$t('question.quizEndShowMsg')}}</div>
    <div :class="isQuizShow ? '' : 'mute-container'">
      <div v-if="questions.length">
        <mu-button icon small color="primary" @click="$emit('onClose')" v-if="isSubmitted && embedMode" class="float-right">
        <mu-icon value="close" />
        </mu-button>
        <div v-if="!embedMode">
          <p v-if="!overDeadline && media.deadline">{{$t('question.deadline')}}: {{stringTimeFormatter(media.deadline)}}</p>
          <p v-if="(overDeadline || !overAnsRelease) && media.answer_release">{{$t('question.answerRelease')}}: {{stringTimeFormatter(media.answer_release)}}</p>
        </div>
        <div v-if="media.trial > 1 && !embedMode">
          <mu-radio
            v-model="modelTrial"
            :value="i"
            v-for="(i, index) in media.trial"
            :key="index"
            v-if="i <= submittedTrials + 1"
            :label="stringTrial(i)"
            class="radio"
            >
          </mu-radio>
        </div>
        <div v-else>
        <b>{{$t('question.score') + ' ' + submissions[0]['count'] + '/' + Math.max(submissions[0]['total'], computedQuestions.length)}}</b>
        </div>
        <div v-for="(question, index) in computedQuestions" :key="index">
          <h3 class="wordwrap quiz-question">{{question.content}}</h3>
          <small v-if="(isSubmitted || overDeadline) && modelTrial === media.trial" class="wordwrap red-text">{{question.prompt}}</small>
          <mu-form :model="submissions[modelTrial - 1]['submissions'][question._id]" label-position="top" label-width="100">
            <div v-if="question.type === 'mc'">
              <div v-for="(answer, index) in question.answers" class="answer-row" :key="index">
                <div class="display-flex">
                  <div v-if="question.multi_select" class="display-flex">
                    <mu-checkbox
                      v-model="submissions[modelTrial - 1]['submissions'][question._id].answer"
                      :value="answer._id"
                      :disabled="isSubmitted || overDeadline"
                      >
                    </mu-checkbox>
                    <div class="flex-item answer-text">{{answer.content}}</div>
                  </div>
                  <div v-else class="display-flex">
                    <mu-radio
                      v-model="submissions[modelTrial - 1]['submissions'][question._id].answer[0]"
                      :value="answer._id"
                      :disabled="isSubmitted || overDeadline"
                      >
                    </mu-radio>
                    <div class="flex-item answer-text">{{answer.content}}</div>
                  </div>
                  <div class="correct-marker" v-if="isSubmitted || overDeadline">
                    <div v-if="question.correct.includes(answer._id)">
                      <mu-icon value="done" color="primary" v-if="submissions[modelTrial - 1]['submissions'][question._id].answer.includes(answer._id)"></mu-icon>
                      <span v-else-if="(media.trial > 1 && modelTrial !== media.trial) || !overAnsRelease" />
                      <mu-icon value="radio_button_unchecked" color="secondary" v-else-if="overAnsRelease"></mu-icon>
                    </div>
                    <div v-else>
                      <mu-icon value="close" color="secondary" v-if="submissions[modelTrial - 1]['submissions'][question._id].answer.includes(answer._id)"></mu-icon>
                    </div>
                  </div>
                </div>
                <div class="answer-feedback-wrapper" v-if="(isSubmitted || overDeadline) && modelTrial === media.trial && submissions[modelTrial - 1]['submissions'][question._id].answer.includes(answer._id)">
                <small class="wordwrap red-text">{{answer.feedback}}</small>
                </div>
              </div>
            </div>
            <div v-else-if="question.type === 'open'">
              <mu-text-field v-model="submissions[modelTrial - 1]['submissions'][question._id].content" :disabled="isSubmitted || overDeadline" multi-line full-width></mu-text-field>
            </div>
            <div v-else-if="question.type === 'turnitin'">
              <LTIForm
                :data="dataLTI(question)"
                service="turnitin"
                />
            </div>
            <div v-else-if="question.type === 'file'">
              <attachment-browser :initIds="submissions[modelTrial - 1]['submissions'][question._id].attachments" :isSubmitted="isSubmitted || overDeadline" @onUpdateAttachments="onUpdateAttachments(payload, question)"/>
            </div>
          </mu-form>
          <mu-flex v-if="isSubmitted" justify-content="end">
            <mu-icon 
              :value="arrayCompare(submissions[modelTrial - 1]['submissions'][question._id].answer, question.correct) ? 'check' : 'close'" 
              :color="arrayCompare(submissions[modelTrial - 1]['submissions'][question._id].answer, question.correct) ? 'primary' : 'secondary'"
              class="correct-marker"
              />
            {{$t('question.score') + ' ' + (arrayCompare(submissions[modelTrial - 1]['submissions'][question._id].answer, question.correct) ? 1 : 0) + '/1'}}
          </mu-flex>
        </div>
        <div class="quiz-submit" v-if="!isSubmitted && !overDeadline">
        <mu-button color="primary" @click="flagDialogSubmit = true">{{$t('question.submit')}}</mu-button>
        </div>
        <mu-dialog :title="$t('question.submit')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogSubmit">
          {{$t('prompt.submitMsg')}}
          <mu-button slot="actions" flat color="primary" @click="flagDialogSubmit = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
          <mu-button slot="actions" flat color="primary" @click="onActionSubmit"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
        </mu-dialog>
      </div>
      <p v-else>{{$t('empty.noDataTitle')}}</p>
    </div>
  </div>

</template>

<script>
// Library
import axios from "axios";

// Components
import LTIForm from '@/components/Common/LTIForm'
import AttachmentBrowser from '@/components/Common/AttachmentBrowser'

import arrayCompare from '@/utils/arrayCompare.js'

export default {
  name: 'QuestionPanel',
  components: {
    LTIForm,
    AttachmentBrowser
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    timestamp: {
      type: Number,
      default: -1
    },
    embedMode: {
      type: Boolean,
      default: false
    },
    currentTime: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      modelTrial: 1,
      media: {},
      questions: [],
      submissions: [],
      flagFetchedMedia: false,
      flagFetchedSubmissions: false,
      submitting: false,
      flagDialogSubmit: false,
      
      videoActions: [],
    }
  },
  computed: {
    // Constant
    valTrue() {
      return true;
    },

    overDeadline() {
      if(this.media.hasOwnProperty('deadlinePass')) {
        return this.media.deadlinePass;
      } else {
        return false;
      }
    },
    overAnsRelease() {
      if(this.media.hasOwnProperty('answerReleasePass')) {
        return this.media.answerReleasePass;
      } else {
        return true;
      }
    },

    submittedTrials() {
      var count = 0;
      this.submissions.forEach(item => {
        if(item.hasOwnProperty('total') && item.total > 0) {
          count++;
        }
      });
      return count;
    },

    computedQuestions() {
      var temp = this.questions.slice();
      temp.forEach(item => {
        if(item.rand_order) {
          var ans = item.answers.slice();
          ans.sort(function(){return 0.5 - Math.random()});
          item.answers = ans;
        }
      });
      return temp;
    },

    isSubmitted() {
      return this.submissions[this.modelTrial - 1]['total'] !== 0
    },
    
    isEnded() {
      if(this.videoActions.length) {
        return this.videoActions.map(i => i.action).includes('end');
      } else {
        return false;
      }
    },
    
    isQuizShow() {
      if(!this.embedMode) {
        if(typeof this.media.quiz_end_show === 'boolean' && this.media.quiz_end_show) {
          if(this.isEnded) {
            return true;
          } else {
            if(this.media.type === 'video' || this.media.type === 'youtube' || this.media.type === 'mp4link') {
              if(this.currentTime >= this.media.duration) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
  watch: {
    mediaId() {
      this.fetchMedia();
      this.fetchSubmissions();
    },
  },
  mounted() {
    this.fetchMedia();
    this.fetchSubmissions();
    this.fetchVideoAction();
  },
  methods: {
    fetchVideoAction() {
      axios.get(this.$store.getters.urlApi + "video/action/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.videoActions = response.data.data.videoActions
      });
    },
    fetchMedia() {
      axios.get(this.$store.getters.urlApi + "media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.media = response.data.data.media
        this.flagFetchedMedia = true;
      });
    },
    fetchSubmissions() {
      this.flagFetchedSubmissions = false;
      axios.get(this.$store.getters.urlApi + "submission/media/" + this.mediaId + "?timestamp=" + this.timestamp, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.submissions = response.data.data.submissions;
        this.questions = response.data.data.questions;
        this.flagFetchedSubmissions = true;
      });
    },

    // String
    stringTimeFormatter(str) {
      if(str) {
        var d = new Date(str);
        var options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: "2-digit", minute: "2-digit", hour12: false };
        return d.toLocaleString("en-GB", options);
      } else {
        return "";
      }
    },
    stringTrial(i) {
      if(this.submissions[i - 1]['total'] !== 0) {
        return this.$t('question.trial') + ' ' + i + ' (' + this.$t('question.score') + ' ' + this.submissions[i - 1]['count'] + '/' + this.submissions[i - 1]['total'] + ')';
      } else {
        return this.$t('question.trial') + ' ' + i;
      }
    },

    dataLTI(question) {
      return {
        'context_id': question.media_id,
        'resource_link_id': question._id,
        'resource_link_title': question.content,
        'resource_link_description': question.type,
        'roles': "Student"
      };
    },

    // Event
    onActionSubmit() {
      this.submitting = true;
      this.flagDialogSubmit = false;
      axios.post(this.$store.getters.urlApi + "submission/media/" + this.mediaId, this.submissions[this.modelTrial - 1]['submissions'], {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
        }
        ).then(() => {
          this.submitting = false;
          this.fetchSubmissions();
          this.$emit('onSubmit');
        });

    },
    onUpdateAttachments(payload, question) {
      this.submissions[this.modelTrial - 1]['submissions'][question._id].attachments = payload;
    },
    
    arrayCompare(a, b) {
      return arrayCompare(a, b);
    },
  }
}
</script>
